var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCongratulationsCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.455,
    height: 91.455,
    viewBox: "0 0 91.455 91.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M353.335 118.036l-3.879-3.974a.805.805 0 0 0-.607-.262.784.784 0 0 0-.619.262l-26.808 27.011-9.769-9.757a.831.831 0 0 0-.607-.262.855.855 0 0 0-.619.262l-3.915 3.915a.857.857 0 0 0-.038 1.211l.038.038 12.3 12.28a3.852 3.852 0 0 0 2.57 1.249 4.079 4.079 0 0 0 2.546-1.19l29.39-29.557a.939.939 0 0 0 0-1.19z",
    transform: "translate(-1450.32 -266.791) translate(1166.153 180.608)",
    style: {
      isolation: "isolate"
    },
    fill: "#14b9b8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.418 96.742a39.563 39.563 0 1 1-27.986 11.59 39.565 39.565 0 0 1 27.986-11.59m0-6.152a45.728 45.728 0 1 0 45.728 45.728 45.715 45.715 0 0 0-45.7-45.728z",
    transform: "translate(-1450.32 -266.791) translate(1162.63 176.201)",
    style: {
      isolation: "isolate"
    },
    fill: "#509ec6",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCongratulationsCheck);
export default __webpack_public_path__ + "static/media/congratulations-check.60016531.svg";
export { ForwardRef as ReactComponent };